import { useQuery } from '@tanstack/react-query';
import { MessagesSquare } from 'lucide-react';
import { COMMUNITY_URL, ladeGemeinschaftszugang } from '@/api/gemeinschaft.api';

// ─── Der Weg in die Gemeinschaft, wenn sonst kein Weg da ist ─────────────────
//
// Die Navigation hängt am Stammbaum: Sie erscheint erst, wenn einer ausgewählt
// ist. Wer noch keinen hat, sieht stattdessen „Noch kein Stammbaum" – und damit
// auch keinen Menüpunkt zum Forum, obwohl sein Tarif es enthält.
//
// Das ist genau der Fall, in dem das Forum am meisten wert wäre: Jemand wartet
// auf eine Freigabe oder weiß nicht, wie er anfangen soll. Ihn auf eine leere
// Seite zu setzen und ihm zugleich den Ort vorzuenthalten, an dem er hätte
// fragen können, wäre die falsche Reihenfolge.
//
// Seit das Forum ein eigener Container unter community.<domain> ist, führt hier
// ein gewöhnlicher Link hinaus statt einer Route hinein. Die Komponente
// entscheidet weiterhin nichts selbst: Ob dieses Konto hineindarf, sagt der
// Server.

export function GemeinschaftWegweiser() {
  const { data } = useQuery({
    queryKey: ['gemeinschaft', 'zugang'],
    queryFn: ladeGemeinschaftszugang,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  if (!COMMUNITY_URL || !data?.lesen) return null;

  return (
    <div className="mt-6 border-t border-slate-100 pt-4">
      <p className="text-sm text-slate-500">
        Fragen zum Anfangen? In der Gemeinschaft sitzen andere, die genau da schon waren.
      </p>
      <a
        href={COMMUNITY_URL}
        className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 hover:text-blue-700"
      >
        <MessagesSquare className="h-4 w-4" aria-hidden="true" />
        Zur Gemeinschaft
      </a>
    </div>
  );
}
